import React from "react";

const TermsAndConditions = ({ terms }) => {
  return (
    <ul className="list-disc pl-5 text-[16px] text-white">
      {terms.map((term, index) => (
        <li key={index} className="mb-2">
          {term}
        </li>
      ))}
    </ul>
  );
};

export default TermsAndConditions;
